<template>
  <div class="d-flex align-items-center justify-content-between flex-wrap mb-1 p-0">
    <div
      class="col-md-3 col-6 p-50"
      v-for="addCard in addCardData"
      :key="addCard.id" 
    >
      <b-card no-body class="mb-50">
        <!-- <b-card-header class="py-1">
      <b-card-title>نگاه کلی</b-card-title> -->
        <!-- <b-card-text class="font-small-2 mr-25 mb-0">
        آخرین بروز رسانی دو دقیقه قبل
      </b-card-text> -->
        <!-- </b-card-header> -->
        <b-card-body class="py-2">
          <b-row v-if="loading">
            <b-col>
              <b-media no-body>
                <b-media-aside class="mr-2">
                  <b-skeleton type="avatar"></b-skeleton>
                </b-media-aside>
                <b-media-body class="mt-75">
                  <b-skeleton />
                </b-media-body>
              </b-media>
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col class="my-xl-0 my-1">
              <b-link :to="addCard.url">
                <b-media no-body>
                  <b-media-aside class="mr-2">
                    <b-avatar size="48" :variant="addCard.color">
                      <feather-icon size="24" :icon="addCard.icon" />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto">
                    <h6 class="font-weight-bolder mb-0">{{ addCard.title }}</h6>
                  </b-media-body>
                </b-media>
              </b-link>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BRow,
  BCol,
  BMedia,
  BMediaAside,
  BAvatar,
  BMediaBody,
  BSkeleton,
  BLink,
} from "bootstrap-vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BLink,
    BSkeleton,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      addCardData: [
        {
          id: 1,
          icon: "TrelloIcon",
          title: "ایجاد ترم",
          color: "success",
          url: "/semesters/add",
        },
        {
          id: 2,
          icon: "ClipboardIcon",
          title: "ایجاد دوره",
          color: "danger",
          url: "/courses/add",
        },
        {
          id: 3,
          icon: "BookOpenIcon",
          title: "ایجاد جلسه",
          color: "primary",
          url: "/sessions/add",
        },
        {
          id: 4,
          icon: "FileTextIcon",
          title: "ایجاد تمرین",
          color: "info",
          url: "/exercises/add",
        },
      ],
    };
  },
};
</script>
